<div class="dropdown-box">
  <button
    type="button"
    class="btn btn-info dropdown-btn"
    [ngClass]="{ show: show }"
    (click)="show = !show"
    [translatable]="{
      transKey: 'shared.export',
      modEnum: translationModulesEnum.shared
    }"
  >
    <i class="bx bxs-download"></i>
    {{ "shared.export" | translate }}
    <i
      class="bx chevron-icon"
      [ngClass]="[show ? 'bx-chevron-up' : 'bx-chevron-down']"
    ></i>
  </button>

  <ul #dropdown class="dropdown-list" [ngClass]="{ show: show }">
    <li
      class="item"
      (click)="onSelect('xlsx')"
      [translatable]="{
        transKey: 'shared.excelFile',
        modEnum: translationModulesEnum.shared
      }"
    >
      {{ "shared.excelFile" | translate }}
    </li>
    <li
      class="item"
      (click)="onSelect('csv')"
      [translatable]="{
        transKey: 'shared.csvFile',
        modEnum: translationModulesEnum.shared
      }"
    >
      {{ "shared.csvFile" | translate }}
    </li>
  </ul>
</div>
